<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view />
  </div>
</template>

<script>
//var path = process.env.NODE_ENV === 'development' ? "" :

//import path;
import './layout/assets/sass/main.scss'
import '@h/'
import layout from './Layout'
import dashboard from './dashboard'
import setting from '@h/setting/components/'
export default {
  name: 'App',
  data() {
    return {
      moduleRoutes: []
    }
  },
  methods: {
    setRouteObject(rte, children) {
      return {
        name: rte.name,
        meta: rte.meta,
        path: rte.path,
        children
      }
    },
    parseRoute(rte) {
      if (rte.children === undefined) {
        return this.setRouteObject(rte, [])
      }

      var children = []
      rte.children.forEach(child => {
        children.push(this.parseRouteChildren(child))
      })

      return this.setRouteObject(rte, children)
    },
    parseRouteChildren(rte) {
      if (rte.children === undefined) {
        return this.setRouteObject(rte, [])
      }

      var children = []
      rte.children.forEach(child => {
        children.push(this.parseRouteChildren(rte.children))
      })

      return this.setRouteObject(rte, children)
    }
  },
  mounted() {
    var modules = modulesName.Modules.split(',')
    var router = {
      path: '/admin',
      name: 'Layout',
      component: layout,
      redirect: 'admin/dashboard/',
      meta: { breadcrumbTitle: 'Administration', breadcrumbClass: 'admin' },
      children: [
        {
          path: 'dashboard/',
          name: 'dashboard',
          component: dashboard,
          meta: { breadcrumbTitle: 'Tableau de bord', header$i18n: 'dashboard' }
        },
        {
          path: 'setting/',
          name: 'setting',
          component: setting,
          meta: { breadcrumbTitle: 'Configuration', header$i18n: 'setting' }
        }
      ]
    }

    var itemsProcessed = 0
    var self = this

    var GetRouter = function() {
      return new Promise((resolve, reject) => {
        modules.forEach(module => {
          var route = () => import('@m/' + module + '/routes')
          route().then(response => {
            itemsProcessed++

            if (response.routes !== undefined) {
              //Menu
              self.moduleRoutes.push(self.parseRoute(response.routes))

              //Router routes
              router.children.push(response.routes)
            }

            if (itemsProcessed === modules.length) {
              resolve(router)
            }
          })
        })
      })
    }

    GetRouter().then(router => {
      // router.children.push({
      //   path: "seo",
      //   name: "seoTest",
      //   component: seoTest,
      //   children: []
      // });
      this.$router.addRoutes([router])
    })

    //axios.post('http://edgar.volcan.dev.dsi.loc/api/account/login', {
    //  email: 'dev@volcan.design',
    //  password: 'bondjames!007'
    //}).then((response) => { })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// shared/App.vue